import { render, staticRenderFns } from "./Products.vue?vue&type=template&id=782db852&scoped=true"
import script from "./Products.vue?vue&type=script&lang=ts"
export * from "./Products.vue?vue&type=script&lang=ts"
import style0 from "./Products.scss?vue&type=style&index=0&id=782db852&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782db852",
  null
  
)

export default component.exports